"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsAudit = void 0;
// add a search header for reports like in providers
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
//  search header
const throttle_debounce_1 = require("throttle-debounce");
const store_2 = require("client/modules/orders/store");
require("./claims-audit.less");
let ClaimsAudit = class ClaimsAudit extends react_1.Component {
    constructor() {
        //  search header
        super(...arguments);
        this.filterText = "";
        this.autoFocusForm = true;
        //   @observable
        //   public sortedBy = {
        //     label: "",
        //     value: ""
        //   };
        this.loadClaims = throttle_debounce_1.debounce(200, (showLoading) => {
            const options = {
                count: 100,
                search: this.filterText,
                start: 0
            };
            store_2.ordersStore.loadOrders(options, showLoading);
        });
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value.toLowerCase();
            this.loadClaims();
        };
    }
    render() {
        return store_1.usersStore.permissions.ReadReports ? (React.createElement("div", null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "claims-audit__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Claims Audit" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "floating-page" },
                    React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Search Claims", callBack: this.onCallback, filterText: this.filterText }))))) : (store_1.usersStore.showLock());
    }
};
__decorate([
    mobx_1.observable
], ClaimsAudit.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], ClaimsAudit.prototype, "autoFocusForm", void 0);
ClaimsAudit = __decorate([
    mobx_react_1.observer
], ClaimsAudit);
exports.ClaimsAudit = ClaimsAudit;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claims-audit/claims-audit.tsx
// module id = 3883
// module chunks = 0